module.exports = __webpack_public_path__ + "static/patient-james-profile-img-80df16163368128c45fed557611d239b.jpg";